import clsxm from '@/lib/clsxm';
import useInterpolation from '@/hooks/use-interpolation';

import { CardStylesClassNames } from '@/components/card';
import HygraphImage, { HygraphImageProps } from '@/components/hygraph-image';
import Link, { LinkVariant } from '@/components/link';
import Typography from '@/components/typography';

import { CardStyle } from '@/enums/card-style';

type FeaturedWithLogoPressCardProps = {
  pressCardImage?: HygraphImageProps;
  headline?: string | null | undefined;
  formatedPublishDate: string;
  link?: string | null | undefined;
};

const FeaturedWithLogoPressCard: React.FC<FeaturedWithLogoPressCardProps> = ({
  pressCardImage,
  headline,
  formatedPublishDate,
  link,
}) => {
  const interpolate = useInterpolation();
  if (pressCardImage) {
    pressCardImage.height = 24;
    pressCardImage.className = 'mt-8 max-w-8';
  }

  return (
    <Link
      className={clsxm(
        'flex gap-8 overflow-hidden',
        CardStylesClassNames[CardStyle.LIGHT_PURPLE]
      )}
      href={link || '#'}
      variant={LinkVariant.LINK_NOTHING}
      target='_blank'
    >
      <div className='min-h-[470px] max-w-full flex-1 break-words px-10 py-12'>
        {pressCardImage && <HygraphImage {...pressCardImage} />}

        {headline && (
          <Typography.Heading2 className='mb-4 mt-6'>
            {interpolate(headline)}
          </Typography.Heading2>
        )}

        {formatedPublishDate && (
          <Typography.Body35 className='mb-4'>
            {interpolate(formatedPublishDate)}
          </Typography.Body35>
        )}
      </div>
    </Link>
  );
};

export default FeaturedWithLogoPressCard;
